import React from "react";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SymbolV2 } from "@bn/api/apiv1";
import { Modal } from "@components";
import { SecuritiesSearch } from "@components/SecuritySearch/SecuritiesSearch";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSymbolSelect: (symbol: SymbolV2) => void;
  isSymbolClickable?: (symbol: SymbolV2) => boolean;
  getSymbolHref?: (symbol: SymbolV2) => string | undefined;
};

export const SearchModal = ({
  isOpen,
  onClose,
  onSymbolSelect,
  isSymbolClickable,
  getSymbolHref,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Modal
      disablePortal={false}
      isOpen={isOpen}
      onClose={onClose}
      height="auto"
      titleMargin={1}
      title={t("securitiesSearch.title")}
      zIndex={10000}
      width={776}
    >
      <Box mt={2}>
        <SecuritiesSearch
          onSymbolSelect={onSymbolSelect}
          isSymbolClickable={isSymbolClickable}
          getSymbolHref={getSymbolHref}
        />
        <Button
          variant="tertiary"
          onClick={onClose}
          sx={{
            marginTop: (theme) => theme.spacing(4),
          }}
        >
          {t("navigation.previous")}
        </Button>
      </Box>
    </Modal>
  );
};
